import { getStorageKey } from 'core/constants/config.utils';

export const KEPT_LOCAL_STORAGE_KEYS = [
  getStorageKey('language'),
  getStorageKey('DEBUG_I18N_KEYS'),
];
